import script from "./CustomTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTab.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTab.vue?vue&type=style&index=0&id=7d9db844&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9db844"]])

export default __exports__